import React from 'react';
import { Icon, IconHover, IconAvatar } from './styles';
var HoverableIcon = function (_a) {
    var icon = _a.icon, hover = _a.hover, avatar = _a.avatar, iconColor = _a.iconColor;
    return (React.createElement(React.Fragment, null,
        icon && React.createElement(Icon, { icon: icon, color: iconColor }),
        hover && React.createElement(IconHover, { icon: hover }),
        avatar && React.createElement(IconAvatar, { src: avatar })));
};
export default HoverableIcon;
